import React from 'react'
import {ReactComponent as CheckIcon} from "assets/img/svg/CheckIcon.svg"
import { getPaymentModeName, paymentModeMapping } from '../components/constant';
import { useGetCollectPaymentContext } from '../../context';
import { formattedPrice } from '../../utils';

const CollectPayment=({module})=>{
    const {
  currentPaymentMode, paymentModeForm, selectedChargesAmount,balanceMode,balanceAmount, 
    } = useGetCollectPaymentContext(module);
    return(
        <div className=' d-flex flex-column align-items-center justify-content-center' style={{minHeight:'212px'}} >
        <span className=" d-flex align-items-center justify-content-center" style={{backgroundColor:'#05945B', border:'1px',  borderRadius:'50%',width:'56px', height:'56px'}}><CheckIcon/></span>
        <div className='mt-2 dark-text label-color'>{balanceAmount==0?'You all set!':`${getPaymentModeName(paymentModeMapping[currentPaymentMode])} payment added`}</div>
        <div className='mt-2' style={{fontWeight:400, fontSize:'16px', lineHeight:'28px'}}>{balanceAmount==0?'Amount to be paid is equal to selected amount.':`${formattedPrice(balanceAmount)} more needs to be collected`}</div>
 </div>
    )
}
export default CollectPayment